import { Component, OnInit } from '@angular/core';
import { AddrollService } from '@app/shared/services/addroll.service';
import { ScriptLoaderService } from '@app/shared/services/script-loader/script-loader.service';
import { decodeToRealUserId, Logger } from '@app/shared/utils';
import { SignupWizardService } from '../signup-wizard.service';
import { SignupChannel } from '../signup.interface';

@Component({
  standalone: false,
  selector: 'sbnb-signup-done',
  templateUrl: './signup-done.component.html',
  styleUrls: ['./signup-done.component.scss'],
})
export class SignupDoneComponent implements OnInit {
  actioning: boolean;
  platform: SignupChannel;
  platformUi: SignupChannel | string;
  isAirbnbSignup = false;

  constructor(
    public wizard: SignupWizardService,
    private scriptLoader: ScriptLoaderService,
    private addrollService: AddrollService
  ) {}

  ngOnInit() {
    this.addrollService.load();

    if (!this.wizard.signupUser.token) {
      this.wizard.cancel();
    } else {
      this.isAirbnbSignup = this.wizard.isAirbnbSignup();

      if (this.hasAirbnbChannel()) {
        this.platform = SignupChannel.Airbnb;
        this.platformUi = this.platform;
      } else if (this.hasVrboChannel()) {
        this.platform = SignupChannel.Vrbo;
        this.platformUi = this.platform;
      } else if (this.hasBookingDotComChannel()) {
        this.platform = SignupChannel.BookingDotCom;
        this.platformUi = 'Booking.com';
      } else {
        this.platform = SignupChannel.Airbnb;
        this.platformUi = this.platform;
      }
    }

    this.registerConversionWithMountain();
  }

  registerConversionWithMountain() {
    // Set the global object with the orderId before loading the script
    // I hate this but don't see an alternative looking at MNTN's current setup
    (window as any).mountainConfig = {
      orderId: decodeToRealUserId(this.wizard.signupUser.id, this.wizard.signupUser.email),
    };

    this.scriptLoader
      .load({
        name: 'Mountain',
        src: '/assets/js/mountain.js',
      })
      .subscribe({
        next: () => {
          Logger.log('Mountain: tracked conversion');
        },
        error: () => {
          Logger.log('Mountain failed to track conversion');
        },
      });
  }

  login() {
    this.actioning = true;

    let redirectUrl;

    if (this.platform === SignupChannel.BookingDotCom) {
      redirectUrl = 'accounts/new/booking';
    }

    if (this.platform === SignupChannel.Vrbo) {
      redirectUrl = 'accounts/new/vrbo';
    }

    this.wizard.updateOnboarding('jumpstart').subscribe(() => {
      this.wizard.flowCompleted(this.hasAirbnbChannel(), redirectUrl);
    });
  }

  doItLater() {
    this.wizard.updateOnboarding('jumpstart').subscribe(() => {
      this.wizard.flowCompleted(false, 'onboarding');
    });
  }

  private hasAirbnbChannel(): boolean {
    return this.wizard.signupUser.platforms.indexOf(SignupChannel.Airbnb) > -1;
  }

  private hasVrboChannel(): boolean {
    return this.wizard.signupUser.platforms.indexOf(SignupChannel.Vrbo) > -1;
  }

  private hasBookingDotComChannel(): boolean {
    return this.wizard.signupUser.platforms.indexOf(SignupChannel.BookingDotCom) > -1;
  }

  private hasDirectChannel(): boolean {
    return this.wizard.signupUser.platforms.indexOf(SignupChannel.Direct) > -1;
  }
}
